import { Steps as BaseSteps } from "antd";
import styled from "styled-components";

import color from "../_style/color";

const Steps = styled(BaseSteps)`
  .ant-steps-item-process .ant-steps-item-icon {
    background: ${color.primary};
    border-color: ${color.primary};
  }
`;

export default Steps;
